import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthRedirectService, FeatureFlagService, getCachedTenantData } from '@laasy/common-layout';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';

export const homeRootBypassGuard: CanActivateFn = async (_route, state) => {
  const featureFlagService = inject(FeatureFlagService);
  const authRedirectService = inject(AuthRedirectService);
  const authenticationService = inject(AuthenticationService);
  const path = state.url.split('?')[0];

  const whitelistedRoutes: string[] = getCachedTenantData()?.homeLayoutCustomization?.hideHomeAppWhitelistedRoutes ?? [];

  if (whitelistedRoutes.some(route => path === route || path.startsWith(route + '/'))) return true;

  await featureFlagService.getFlags();
  const hideHomeApp = featureFlagService.hideHomeApp
  if(!hideHomeApp) return true;

  const defaultProductUrl = localStorage.getItem('defaultProduct');
  if(!defaultProductUrl) return true

  const isRootDomain = window.location.href === window.location.origin || window.location.href === window.location.origin + '/';
  const currentSession = await authenticationService.GetCurrentSession();
  if (isRootDomain && currentSession === null) return true;

  authRedirectService.startSwitchingProcess(defaultProductUrl);
  return false;
};
